import {
  CircularProgress as MUICircularProgress,
  CircularProgressProps,
} from '@mui/material';
import { useEffect, useRef } from 'react';

const CircularProgress = (props: CircularProgressProps) => {
  const svgRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (svgRef.current) {
      svgRef.current.children[0].setAttribute('role', 'img');
      svgRef.current.children[0].setAttribute('aria-label', 'loading');
    }
  }, [svgRef.current]);

  return (
    <MUICircularProgress
      role="alert"
      aria-busy="true"
      ref={svgRef}
      {...props}
    />
  );
};

export default CircularProgress;
